<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh" id="ack"><a href="#/xhtml/contents#c_ack"><span class="epub-sc">ACKNOWLEDGMENTS</span></a></p>
<p class="co">Special thanks to Monique Patterson, editor extraordinaire, who believed in this project, and to the wonderful fans who warmly embraced <span class="epub-i">Welcome to Leo’s</span> and wanted the Hardcastles to have their own story.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?1c6b252a